import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage, type LoginMethod } from '@/features/auth/components/login-page';
import { sessionStore } from '@/shared/auth/session-store';
import { safeRedirectPath } from '@/shared/lib/redirect';

const searchSchema = z.object({
  /** 로그인 후 돌아갈 경로 (같은 사이트 안) */
  redirect: z.string().optional().catch(undefined),
  method: z.enum(['qr', 'email']).optional().catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (sessionStore.get()) {
      throw redirect({ href: safeRedirectPath(search.redirect), replace: true });
    }
  },
  head: () => ({ meta: [{ title: '로그인 · 팬즈드롭 파트너' }] }),
  component: LoginRoute,
});

function LoginRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <LoginPage
      method={search.method ?? 'email'}
      redirect={search.redirect}
      onMethodChange={(method: LoginMethod) => {
        void navigate({ search: previous => ({ ...previous, method }), replace: true });
      }}
    />
  );
}
